import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import {
  PlanFeedbackGenericSlotType,
  planFeedbackTransactionActionType
} from '../builders/plan_feedback_transaction_type';

export interface IFeedbackSelectedLinkedSuggestionModel {
  nks?: string[];
  resolutionIds?: number[];
  type?: PlanFeedbackGenericSlotType;
  action?: planFeedbackTransactionActionType;
}

export type FeedbackSelectedLinkedSuggestionModel = ITypedModel<IFeedbackSelectedLinkedSuggestionModel>;

angular.module('capability-ng-academic-planner').factory(
  'ngFeedbackSelectedLinkedSuggestionModel',
  (): FeedbackSelectedLinkedSuggestionModel =>
    new Model<IFeedbackSelectedLinkedSuggestionModel>({
      nks: [],
      type: undefined,
      resolutionIds: []
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/models/feedback_selected_linked_suggestion_model.ts